import { render } from "./Logos.vue?vue&type=template&id=5a509bea"
import script from "./Logos.vue?vue&type=script&lang=js"
export * from "./Logos.vue?vue&type=script&lang=js"

import "./Logos.vue?vue&type=style&index=0&id=5a509bea&lang=scss"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__